const QueryMixin = {
  data() {
    return {
      loading: false,
      data: null,
      ready: false,
      error: false,
      errorMessage: ""
    };
  },

  methods: {
    async getData() {},

    responseToData(response) {
      return response;
    },

    resetError() {
      this.error = false;
      this.errorMessage = "";
    },

    applyError(message) {
      this.error = true;
      this.errorMessage = message;
    },

    handleError(error) {
      if (!error.response) {
        this.handleGenericException(error);
        return;
      }

      if (error.response.status === 404) {
        this.handleNotFound(error);
        return;
      }

      if (error.response.status === 422) {
        this.handleFormException(error);
        return;
      }
    },

    handleNotFound(error) {
      this.applyError("Página não encontrada");
    },

    handleGenericException(error) {
      this.applyError("Erro não identificado");
    },

    handleFormException(error) {
      this.applyError("Corrija o formulário");
    },

    async refresh() {
      this.loading = true;

      try {
        const response = await this.getData();
        this.data = this.responseToData(response);
        this.ready = true;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {
    emptyData() {
      return this.ready && this.data.length < 1;
    }
  },

  created() {
    this.refresh();
  }
};

export default QueryMixin;
